export function rollingAvg(values: Array<number | null>, index: number, window: number): number {
  const start = Math.max(0, index - window + 1);
  let sum = 0;
  let count = 0;
  for (let i = start; i <= index; i++) {
    const v = values[i];
    if (typeof v === "number" && Number.isFinite(v)) {
      sum += v;
      count++;
    }
  }
  return count === 0 ? 0 : sum / count;
}

export function formatAxis(value: number | string, isDaily: boolean): string {
  if (isDaily) return String(value).slice(5);
  const d = new Date((value as number) * 1000);
  return `${d.getMonth() + 1}/${d.getDate()} ${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
}
